import { useFormikContext } from 'formik'
import { MouseEvent, ReactNode } from 'react'

export default function ValidationButton({children, disabled=false}:{children:ReactNode, disabled?:boolean}) {

    const {handleSubmit} = useFormikContext()

    const handleOnSubmit = (e:MouseEvent<HTMLButtonElement>)=>{
        e.preventDefault()
        handleSubmit()
    }
    
  return (
    <button 
        onClick={handleOnSubmit} 
        type="submit" 
        className="w-full lg:w-1/5 p-2 bg-black text-white mt-4 rounded"
        disabled={disabled}
    >
        {children}
    </button>
  )
}
